import { useNavigate, useParams } from "react-router";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import EditUtmifyForm from "../../../components/apps/utmify/EditUtmifyForm";

export default function EditUtmify() {
    const navigate = useNavigate();
    const { integrationId } = useParams();

    const handleGoBack = () => {
        navigate(`/apps/utmify`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Editar Integração UTMify"
                description="Editar integração UTMify"
            />
            <PageBreadcrumb
                pageTitle="Editar Integração UTMify"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <EditUtmifyForm
                    integrationId={integrationId}
                    onSuccess={() => {
                        navigate(`/apps/utmify`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao atualizar integração UTMify:", error);
                    }}
                />
            </div>
        </>
    );
}
